module.exports = __webpack_public_path__ + "static/media/WebPage.d6d7485a.jpg";